var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg138213(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A98258"
    },
    points: "48,0 10,0 0,16 0,58 58,58 58,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DAAE86"
    },
    points: "10,0 0,16 58,16 48,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8B18B"
    },
    points: "33,54 29,50 25,54 23,52 23,58 35,58 35,52  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    style: {
      fill: "#E8D5B2"
    },
    width: 18,
    height: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M30,41h-6c-0.552,0-1,0.447-1,1s0.448,1,1,1h6c0.552,0,1-0.447,1-1S30.552,41,30,41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M34,41h-1c-0.552,0-1,0.447-1,1s0.448,1,1,1h1c0.552,0,1-0.447,1-1S34.552,41,34,41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M28,35h6c0.552,0,1-0.447,1-1s-0.448-1-1-1h-6c-0.552,0-1,0.447-1,1S27.448,35,28,35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M34,37h-2c-0.552,0-1,0.447-1,1s0.448,1,1,1h2c0.552,0,1-0.447,1-1S34.552,37,34,37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M24,39h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S23.448,39,24,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M24,35h1c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1c-0.552,0-1,0.447-1,1S23.448,35,24,35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4C3A5"
    },
    d: "M28.29,37.29C28.11,37.479,28,37.729,28,38c0,0.27,0.11,0.52,0.29,0.71C28.48,38.89,28.74,39,29,39 c0.26,0,0.52-0.11,0.71-0.29C29.89,38.52,30,38.26,30,38s-0.11-0.521-0.29-0.71C29.33,36.92,28.66,36.92,28.29,37.29z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    style: {
      fill: "#F4D5BD"
    },
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8B18B"
    },
    points: "25,21 29,25 33,21 35,23 35,16 23,16 23,23  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg138213);
export default __webpack_public_path__ + "static/media/138213.c4779b7aa19dc6b253f1aa0aeafc7aa7.svg";
export { ForwardRef as ReactComponent };